/**
 * Cebuano (Bisaya).
 *
 * Same principle as Tagalog: the product words stay in English because that
 * is how they are said in Cebu, Davao and the rest of the Visayas and
 * Mindanao. Written in the everyday register rather than the formal one used
 * in liturgy and textbooks, which is what a shop should sound like.
 */
export default {
  nav: {
    home: 'Home',
    services: 'Mga Serbisyo',
    faq: 'FAQ',
    help: 'Tabang',
    signIn: 'Mag-sign in',
    getStarted: 'Sugod',
    openPanel: 'Ablihi ang panel',
    language: 'Pinulongan',
    currency: 'Kwarta',
  },

  common: {
    perThousand: 'kada 1,000',
    from: 'Sugod sa {amount} kada 1,000',
    noSubscription: 'Walay subscription',
    neverPassword: 'Wala gyud mangayo ug password',
    cancel: 'Kanselahon',
    done: 'Human na',
    total: 'Tanan',
    rate: 'Presyo',
    range: 'Gilapdon',
    starts: 'Magsugod',
    refill: 'Refill',
    quantity: 'Gidaghanon',
    lowest: 'pinakabarato',
    services: 'serbisyo',
    platforms: 'platform',
    shownIn: 'Gipakita sa {display} sa palitan karon · singilon sa {platform}',
    chargedIn: 'Singilon sa {code}',
    cancelWhilePending: 'samtang pending pa ang order',
    notOffered: 'wala',
    chargedAs: 'singilon isip {amount}',
  },

  home: {
    refresh: {
      titleA: 'Mga serbisyo sa social media.',
      titleB: 'Klaro nga presyo. Masubay nga order.',
      lede: 'Tan-awa ang followers, likes ug views para sa TikTok, Instagram ug YouTube. Susiha ang presyo, gibanabana nga paghatod ug mga kondisyon sa refill sa dili pa ka mag-order.',
      eyebrowIdle: 'Susiha ang among mga serbisyo',
      demo: 'Demo sa pagsubay sa order',
      demoNote: 'Pananglitan nga mga order · ang animation 60× ang kapaspas',
      servicesKey: 'Susiha ang katalogo',
      servicesTitle: 'Pangitaa ang serbisyo nga angay nimo.',
      servicesBody: 'Ikumpara ang kasamtangang presyo ug mga kondisyon sa serbisyo sa dili pa maghimo og account. Ang oras sa pagsugod banabana ra, dili garantiya nga mahuman.',
      perThousand: 'kada 1,000',
      minimum: 'Minimum nga gidaghanon',
      start: 'Gibanabana nga pagsugod',
      notListed: 'Wala gilista',
      refill: 'Sakop sa refill',
      days: '{count} ka adlaw',
      seeTerms: 'Tan-awa ang mga kondisyon sa serbisyo',
      details: 'Tan-awa ang detalye sa serbisyo',
      loading: 'Gikarga ang kasamtangang mga serbisyo…',
      empty: 'Walay serbisyo nga ma-preview karon. Susiha ang katalogo kung unsay anaa.',
      currencyNote: 'Ang gi-convert nga presyo banabana ra. Susiha ang currency sa bayad ug ang final nga total sa dili pa magbayad.',
      faqKey: 'Sa dili pa ka mag-order',
      faqTitle: 'Hibaloa kung unsay paabuton.',
      moreAnswers: 'Dugang tubag sa mga pangutana',
      closingTitle: 'Pangitaa ang imong unang serbisyo.',
      closingBody: 'Ikumpara ang presyo ug mga kondisyon. Pilia ang gidaghanon kung andam na ka.',
      steps: {
        chooseTitle: 'Pagpili og serbisyo',
        chooseBody: 'Pangitaa pinaagi sa platform ug ikumpara ang presyo, minimum nga gidaghanon ug sakop sa refill.',
        reviewTitle: 'Susiha ang detalye',
        reviewBody: 'Isulod ang imong public link ug gidaghanon. Susiha ang total, gibanabana nga paghatod ug mga kondisyon sa serbisyo sa dili pa mo-confirm.',
        trackTitle: 'Subaya ang imong order',
        trackBody: 'Sundi ang gi-report nga status sa imong account. Kontaka ang support kung mahunong ang order o kung ang resulta nanginahanglan og atensyon.',
      },
      faq: {
        deliveryTitle: 'Unsa kadugay ang paghatod?',
        deliveryBody: 'Ang oras magdepende sa serbisyo ug gidaghanon. Ang gibanabana nga pagsugod nagpasabot kung kanus-a mahimong magsugod ang paghatod, dili kung kanus-a kini mahuman. Mahimong maglangan; kontaka ang support kung ang imong order molapas sa gibanabana nga oras.',
        dropsTitle: 'Mahimo bang mokunhod ang followers o ubang ihap?',
        dropsBody: 'Oo. Ang ihap mahimong mokunhod human sa paghatod. Ang mga serbisyo lang nga adunay sakop sa refill ang kwalipikado sa puli, sulod sa ilang gilista nga panahon ug kondisyon. Ang mga serbisyo nga walay refill walay apil nga puli.',
        refundsTitle: 'Asa moadto ang mga refund?',
        refundsBody: 'Kung makumpirma nga gikansela o partial ang order, ang kwalipikado nga kantidad nga wala mahatod ibalik sa imong PresenceRise wallet. Kini account credit, dili refund sa imong card. Ang order nga nagpadayon pa dili awtomatik nga ma-refund tungod lang kay naglangan kini.',
        passwordTitle: 'Kinahanglan ba nako ihatag ang password sa akong social media?',
        passwordBody: 'Dili. Ang mga order naggamit sa imong public profile o link sa post. Ayaw gyud iapil ang imong password o login code sa order o mensahe sa support.',
        paymentsTitle: 'Unsang mga paagi sa pagbayad ang magamit nako?',
        paymentsBody: 'Ang magamit nga mga paagi makita sa checkout o sa pagdugang og pondo. Mahimong magkalahi kini depende sa nasud ug currency. Susiha ang mga opsyon ug bisan unsang bayranan sa dili pa magbayad.',
      },
    },
    eyebrow: '{count} ka serbisyo nga live sa {platforms} ka platform',
    eyebrowIdle: 'Nagdawat na ug order',
    titleA: 'Pagtubo nga',
    titleB: 'imong makita.',
    lede: 'Followers, likes, views ug subscribers, presyo kada libo ug gihatod pinaagi sa pipeline nga imong makita. Kada order gisubay nga live, gisukod human, ug awtomatik nga girefund o girefill kung kulang.',
    ctaStart: 'Sugdi nga libre',
    ctaBrowse: 'Tan-awa ang mga serbisyo',
    ctaOrder: 'Mag-order',
    delivering: '{count} nagahatod',
    illustration: 'Panig-ingnan lang, 60× ka kusog',
    figures: {
      services: 'serbisyo',
      platforms: 'platform',
      from: 'sugod, kada 1,000',
      refill: 'nga adunay refill window',
      remeasured: 'ka adlaw nga gisukod pag-usab ang kada order',
      tickets: 'ka ticket nga gikinahanglan para sa refund',
    },
    life: {
      key: 'Ang kinabuhi sa usa ka order',
      title: 'Unom ka butang ang mahitabo sa kada order. Wala niini ang kinahanglan nimong buhaton.',
      pricedTitle: 'Gipresyo sa server',
      pricedBody:
        'Ang imong gidaghanon gipresyo sa samang code nga gigamit sa API. Ang gidaghanon nga imong giuyonan mao ang singilon.',
      chargedTitle: 'Kausa ra singilon',
      chargedBody:
        'Kuhaon sa imong wallet sa higayon nga mahimo ang order, ug dili na usab para niana nga order.',
      sentTitle: 'Gipadala ug gisubay',
      sentBody:
        'Giruta sa provider nga labing maayo mohatod para nianang serbisyo, dayon gisubay hangtod mahuman.',
      deliveringTitle: 'Nagahatod',
      deliveringBody:
        'Makita sa Climb: asa ka nagsugod, asa ka karon, ug asa ka moabot sa kasamtangang kakusgon.',
      measuredTitle: 'Gisukod sa 1, 7 ug 30 ka adlaw',
      measuredBody:
        'Gibasa pag-usab ang gihatod ug gitandi sa naa sa paghuman. Gipatik ang porsyento nga nagpabilin.',
      settledTitle: 'Awtomatik nga girefill o girefund',
      settledBody:
        'Ang pagkunhod sulod sa refill window awtomatik nga magpadala ug refill. Ang kulang nga paghatod ibalik sa imong wallet.',
    },
    kept: {
      key: 'Ngano nga dili mi ang pinakabarato',
      title: 'Ang pinakabaratong follower mao ang nagpabilin.',
      body: 'Ang mas baratong presyo nga mawad-an ug ikatulo sa gihatod mas mahal kada follower nga nagpabilin kaysa mas mahal nga nagpabilin. Kada order giruta base sa presyo kada nabilin nga unit, dili sa nakasulat nga presyo, ug ang retention figure nakabutang sa serbisyo aron imong makita.',
      link: 'Ang tibuok tubag, sa FAQ',
      sticker: 'Nakasulat nga presyo',
      held: 'Nabilin sa 30 ka adlaw',
      effective: 'Kada 1,000 nga nabilin',
      cheaper: 'Ang mas baratong listing',
      ours: 'Ang among gipili',
      foot: 'Panig-ingnang datos. Ang tinuod naa sa kada serbisyo, uban sa sample size.',
    },
    steps: {
      fundsTitle: 'Pagbutang ug pondo',
      fundsBody: 'Card, o GCash, Maya ug GrabPay sa Pilipinas. Walay subscription.',
      pickTitle: 'Pagpili ug serbisyo',
      pickBody:
        'Pilia ang gusto nimo, i-paste ang public link, ug makita nimo ang eksaktong total sa dili pa nimo kumpirmahon.',
      watchTitle: 'Tan-awa nga mosaka',
      watchBody:
        'Live nga gisubay ang paghatod. Ang kulang nga order awtomatik nga girefund; ang pagkunhod awtomatik nga girefill.',
    },
    cta: {
      title: 'Andam mi kung andam ka na.',
      body: 'Walay subscription, walay minimum nga gasto, ug wala gyud mangayo ug password.',
      account: 'Paghimo ug account',
    },
  },

  services: {
    key: 'Mga Serbisyo',
    titleA: 'Kada serbisyo,',
    titleB: 'kada presyo.',
    lede: 'Usa ka kalibrado nga price axis kada resulta, mao nga ang pagkatag sa mga marka mao mismo ang merkado. Tanang presyo kada 1,000 units, ug walay idugang sa checkout. I-click ang usa ka row aron presyohan ang tinuod nga gidaghanon.',
    quality: 'Kalidad',
    region: 'Rehiyon',
    anyQuality: 'Bisan unsang kalidad',
    anyRegion: 'Bisan asang rehiyon',
    allPlatforms: 'Tanang platform',
    search: 'Pangitaa ang serbisyo',
    refillOnly: 'Adunay refill lang',
    sort: 'Ayoha',
    sortPrice: 'Presyo',
    sortRetention: 'Retention',
    sortName: 'Ngalan',
    empty: 'Walay serbisyo nga mohaum',
    emptyBody: 'Sulayi ang laing pangita o kuhaa ang mga filter.',
    showEverything: 'Ipakita tanan',
    priceIt: 'Presyohi',
    priceEmpty:
      'I-click ang bisan unsang row ug mogawas dinhi ang presyo para sa tinuod nga gidaghanon — ang mao ra nga gidaghanon nga singilon sa order form.',
    order: 'Orderha kini',
    orderGuest: 'Paghimo ug account aron makaorder',
    includes: 'Unsay apil sa presyo',
    terms: {
      perThousandTitle: 'Ang presyo kada 1,000 units',
      perThousandBody:
        'Parehas ang paagi sa pagpresyo, mao nga direkta ma-compare ang bisan asa. Ang $1.23 para sa 1,000; ang 500 katunga niana.',
      totalTitle: 'Gikalkula ang total sa dili pa nimo kumpirmahon',
      totalBody:
        'Ang imong gidaghanon gipresyo sa among server ug gipakita nga tibuok. Ang gidaghanon nga imong giuyonan mao ang singilon — walay idugang sa checkout.',
      balanceTitle: 'Nagdugang ka ug balanse, dili subscription',
      balanceBody:
        'Pagbutang ug pondo kung kinahanglan nimo ug gasto gikan didto. Walay balik-balik nga bayad, walay binulan nga minimum.',
      refundTitle: 'Awtomatik nga girefund ang kulang nga order',
      refundBody:
        'Kung kulang ang gihatod, ang wala mahatod awtomatik nga mobalik sa imong balanse. Dili nimo kinahanglan mamatikdan o mag-abli ug ticket.',
      refillTitle: 'Daghang serbisyo ang adunay refill window',
      refillBody:
        'Kung adunay refill ang serbisyo, nakasulat ang gitas-on niini sa row, ug kami na ang magpadala ug refill kung adunay makit-an nga pagkunhod ang retention check.',
    },
  },

  auth: {
    signInKey: 'Mag-sign in',
    signInTitle: 'Maayong pagbalik.',
    signInLede: 'Naa ra gihapon ang imong mga order, balanse ug tanang nagsaka pa.',
    identifier: 'Username o email',
    password: 'Password',
    passwordPlaceholder: 'Ang imong password',
    passkey: 'Mag-sign in gamit ang passkey',
    or: 'o',
    forgot: 'Nakalimtan?',
    remember: 'Magpabiling naka-sign in ug 30 ka adlaw',
    newHere: 'Bag-o dinhi?',
    createAccount: 'Paghimo ug account',
    show: 'Ipakita',
    hide: 'Itago',

    registerKey: 'Paghimo ug account',
    registerTitle: 'Mag-order sa wala pay usa ka minuto.',
    registerLede: 'Username ug password ra ang kinahanglan.',
    registerCarries: 'Naghulat sa pikas ang serbisyo nga imong gipili.',
    registerClosed: 'Sirado sa una ang pagparehistro. Balika na lang unya.',
    username: 'Username',
    usernameHint: 'Mga letra, numero, tuldok, gitlin ug underscore.',
    newPassword: 'Password',
    newPasswordPlaceholder: 'Dili mominus sa 10 ka karakter',
    noEmailTitle: 'Dili kinahanglan ug email aron magsugod',
    noEmailBody:
      'Makadugang ka sa checkout. Samtang wala, dili namo mabawi ang imong account, mao nga ang account nga walay email tangtangon human sa 5 ka adlaw. Ang pagdugang ug email magpabilin niini — ug ang bisan unsa nga imong nabayran dili gyud awtomatik nga tangtangon.',
    agreeA: 'Miuyon ko sa',
    terms: 'Mga Termino sa Serbisyo',
    agreeB: 'ug',
    privacy: 'Patakaran sa Privacy',
    haveAccount: 'Naa nay account?',

    caseKey: 'Unsaon pag-order dinhi',
    caseTitle: 'Pagtubo nga imong makita.',
    caseNoEmailTitle: 'Dili kinahanglan ug email aron magsugod',
    caseNoEmailBody:
      'Username ug password ra. Makadugang ka ug email sa checkout, diin resibo kini ug dili babag.',
    casePricedTitle: 'Gipresyo sa dili pa nimo kumpirmahon',
    casePricedBody:
      'Kada total gikalkula sa among server ug gipakita nga tibuok. Ang gidaghanon nga imong giuyonan mao ang singilon.',
    caseSettledTitle: 'Awtomatik nga girefund o girefill',
    caseSettledBody:
      'Ang kulang nga paghatod mobalik sa imong wallet nga walay ticket. Ang pagkunhod sulod sa refill window kami na ang bahala.',
    backToSite: 'Balik sa site',
  },

  upsell: {
    title: 'Himoa nga mura og organic',
    sameLink: 'Tanan dinhi ihatod sa samang link sa order sa ibabaw.',
    why: {
      likesForPlays: 'Ang plays nga adunay kauban nga likes ang magpakita nga nagsikat ang track.',
      likesForViews:
        'Ang video nga adunay views apan walay likes mura og gipalit. Ang likes nga pipila ka porsyento sa views mura og adunay tinuod nga nagtan-aw.',
      viewsForLikes:
        'Lahi ang likes nga walay views: walay mo-like sa video nga wala nila matan-aw, ug sa bag-ong video, makita ang ratio.',
      subsForViews:
        'Pipila sa matag libo nga nagtan-aw ang mo-follow. Ang views nga walay kauban nga tawo mura og numero lang, dili audience.',
      likesForFollowers:
        'Mamatikdan ang mga bag-ong follower nga walay gi-like. Pipila ka likes sa bag-ong mga post ang magpakita nga tawo ang pagtubo.',
      viewsForSubs:
        'Gikan ang subscribers sa mga video nga natan-aw. Ang views sa pinakabag-ong video ang magpasabot sa mga bag-ong subscriber.',
      likesForSubs: 'Ang mo-subscribe kasagaran adunay gi-like una.',
      followersForPlays:
        'Ang plays gikan sa mga naminaw nga mi-follow human ang magpakita nga nagsikat ang track.',
      likesForComments:
        'Makita kung mas daghan ang comments kaysa likes. Kadaghanan sa nag-comment mo-like usab.',
      likesForShares: 'Panagsa ra ang shares nga walay likes; ang likes ang magpatuo sa shares.',
      viewsForReactions:
        'Mamatikdan ang reactions sa post nga gamay ra ang nakakita. Views una, dayon mura og tinuod ang reactions.',
    },
  },

  guest: {
    orderWithout: 'Mag-order nga walay account',
    orderTitle: 'Mag-order isip guest',
    orderLede:
      'Bayad, ug nabutang na ang order. Ang resibo sa email adunay one-click link aron maghimo og account nga naa na ang order niini.',
    email: 'Email para sa resibo',
    emailHint: 'Dinhi ipadala ang detalye sa order ug ang link aron maghimo og account. Wala nay lain.',
    linkLabel: 'Link o username',
    linkHint: 'Link sa public nga profile o post. Dili mahatod sa private nga account.',
    payWith: 'Bayad gamit ang',
    noMethods: 'Gi-andam pa ang mga pagbayad. Mag-sign in aron mag-order gikan sa imong balanse.',
    pay: 'Bayad og {amount}',
    methods: {
      xenditPhLabel: 'GCash, Maya ug bank transfer',
      xenditPh: 'Apil ang GrabPay, ShopeePay ug over-the-counter sa 7-Eleven',
      xenditId: 'OVO, DANA, bank transfer ug retail outlets',
      local: 'Singilon sa {currency} · walay conversion',
    },
    feeNote: 'Apil ang {fee} nga bayad sa {method}, aron bug-os ang bayad sa order.',
    minimumNote:
      'Ang minimum para niini nga paagi kay {amount}; magpabilin ang sobra isip balanse sa imong account.',
    basket: 'Basket',
    haveAccount: 'Naa nay account?',
    status: {
      eyebrow: 'Imong order',
      waitingTitle: 'Gikumpirma ang imong bayad.',
      waitingLede:
        'Gisulti sa amo sa payment processor nga natuloy kini. Pipila ka segundo lang kasagaran; ang page mo-update ra.',
      placedTitle: 'Nabutang na ang imong order.',
      placedLede:
        'Magsugod ra ang paghatod. Padulong na ang resibo sa imong email, uban ang link nga maghimo niini nga imong account.',
      failedTitle: 'Wala matuloy ang bayad.',
      failedLede: 'Walay gisingil ug walay gibutang. Makasugod ka pag-usab bisan kanus-a.',
      canceledLede: 'Gikansela ang bayad sa wala pa mahuman. Walay gisingil.',
      reference: 'Reference',
      paid: 'Gibayad',
      email: 'Resibo sa',
      polling: 'Naghulat sa processor…',
      failedItems:
        '{count} ka item ang wala mabutang. Gihuptan ang kwarta isip balanse sa imong account; gipasabot sa email.',
      nextKey: 'Sunod',
      nextBody:
        'Ablihi ang email ug i-click ang "Create my account". Mopili ka og username ug password, ug makita na nimo ang mga order — adunay live nga paghatod, refill ug refund nga kami na ang bahala. 30 ka adlaw ang link.',
      help: 'Help centre',
      tryAgain: 'Sulayi pag-usab',
      notFound: 'Wala namo makita kanang bayad.',
    },
    claim: {
      key: 'Paghimo og account',
      loading: 'Kadiyot lang…',
      title: 'Pagpili og username ug password.',
      lede: 'Mao ra na. Naa na sa account ang imong {count} ka bayad nga order.',
      emailConfirmed: 'Kumpirmado ang {email} — gi-click nimo ang link nga among gipadala dinhi.',
      submit: 'Paghimo og account ug tan-awa ang mga order',
      invalidTitle: 'Expired na kini nga link.',
      invalidLede:
        '30 ka adlaw ang claim link. Kung nakahimo ka na og account, mag-sign in; kung wala, pangutana sa help centre ug isulti ang imong order number.',
    },
  },

  footer: {
    tagline: 'Pagtubo nga imong makita.',
    blurb:
      'Susiha ang mga serbisyo sa social media nga adunay klaro nga presyo ug pagsubay sa order. Ang gibanabana nga paghatod, sakop sa refill ug kwalipikasyon sa refund nagdepende sa serbisyo.',
    startKey: 'Sugdi sa wala pay usa ka minuto',
    createAccount: 'Paghimo ug account',
    getHelp: 'Pangayo ug tabang',
    startNote:
      'Igo na ang username ug password. Ang suporta moagi sa mga ticket, nakadikit na sa imong account ug mga order.',
    product: 'Produkto',
    help: 'Tabang',
    legal: 'Legal',
    platforms: 'Mga platform',
    pricing: 'Presyo',
    signIn: 'Mag-sign in',
    helpCentre: 'Help centre',
    terms: 'Mga termino sa serbisyo',
    privacy: 'Patakaran sa privacy',
    rights: '© {year} {site}. Tanang katungod gitagana.',
    mono: 'Presyo kada 1,000 · susiha ang total sa dili pa magbayad',
    notAffiliated: 'Walay kalabotan sa bisan unsang social media platform.',
    top: 'Ibabaw',
  },

  faq: {
    eyebrow: 'Help centre',
    titleA: 'Ang mga angay pangutan-on',
    titleEm: 'sa dili pa',
    titleB: 'ka mobayad',
    lede: 'Lakip ang mga adunay dili komportable nga tubag. Kung wala dinhi, pangutana — nagdako kini nga lista gikan sa tinuod nga pangutana sa mga tawo.',
    searchPlaceholder: 'Pangita sa {count} ka pangutana',
    searchLabel: 'Pangita ug pangutana',
    clearSearch: 'Papasa ang gipangita',
    try: 'Sulayi',
    suggestions: 'refund, password, GCash, kanselahon, mokunhod',
    topics: 'Mga hilisgutan',
    ofTotal: 'sa {total}',
    inTopic: 'sa {topic}',
    matching: 'nga motakdo sa “{query}”',
    showAll: 'Ipakita tanan',
    emptyTitle: 'Walay motakdo sa “{query}”.',
    emptyText:
      'Sulayi ang laing pulong, o pangutana direkta — ang pangutana nga walay tubag ang nagpadako niini nga lista.',
    previous: 'Miagi',
    next: 'Sunod',
    stillUnsure: 'Dili pa sigurado? Mag-open ug ticket',
    contactKey: 'Stuck gihapon?',
    contactTitle: 'Pangutan-a ang mga tawong nagpadagan niini',
    contactText:
      'Moagi ang suporta sa mga ticket sulod sa panel, dili sa inbox. Moabot kini sa samang mga tawo, ug moabot nga nakataod na sa imong account ug mga order — busa walay kinahanglan mangayo nimo ug order number.',
    contactNote: 'Wala pay account? Username ug password ra ang kinahanglan, ug mga katloan ka segundo.',
    openTicket: 'Mag-open ug ticket',
    createAccount: 'Paghimo ug account',
    groups: {
      quality: {
        label: 'Kalidad ug pagkunhod',
        blurb: 'Kung magpabilin ba sila, ug unsa ang among buhaton kung dili.',
      },
      orders: { label: 'Mga order', blurb: 'Kapaspason, link, kulang nga delivery ug pagkansela.' },
      money: { label: 'Mga bayad', blurb: 'Pagbayad, presyo sa rehiyon ug ang imong wallet.' },
      account: {
        label: 'Account ug kaluwasan',
        blurb: 'Password, risgo sa platform, pag-sign up, imong data.',
      },
    },
    q: {
      retention: {
        q: 'Magpabilin ba ang mga followers, o mawala?',
        a1: 'Adunay mokunhod. Kung adunay moingon nga dili, adunay ilang gibaligya nimo — mapapas ang mga account, mag-unfollow ang mga tawo, ug gikuha sa mga platform ang peke nga engagement nga dinungan.',
        a2: 'Ang kalainan dinhi mao nga among gisukod kini. Matag nahuman nga order gisusi pag-usab sa 1, 7 ug 30 ka adlaw ug gitandi ang gihatod nga ihap sa ihap sa dihang nahuman. Kung igo na ang data, nakasulat sa order form tapad sa presyo ang porsyento nga nagpabilin, uban sa pila ka order ang gisukod.',
        a3: 'Among gipatik kana nga numero bisan daotan. Ang serbisyong nagpabilin sa 78% gipakita nga 78%.',
      },
      refill: {
        q: 'Unsa ang mahitabo kung mokunhod ang akong order?',
        a1: 'Sa serbisyong adunay refill guarantee, kami na ang mopadala sa refill. Dili nimo kinahanglan mamatikdan, ug dili nimo kinahanglan mangayo — ang samang pagsukod nga naghatag sa retention figure ang mo-trigger sa puli.',
        a2: 'Kini ang labing kasagarang reklamo niini nga industriya: refill guarantee nga gibaligya ug hilom nga gibaliwala kung adunay gustong mogamit. Ang pagkuha sa pagpangayo mao ang punto.',
      },
      qualityVsPrice: {
        q: 'Ngano nga dili kamo ang labing barato?',
        a1: 'Kay ang labing barato kasagaran dili ang labing barato. Ang usa ka libo ka followers nga mas barato apan mawad-an ug ikatulo mas mahal kada follower nga magpabilin kaysa mas mahal nga magpabilin.',
        a2: 'Among gipadala ang matag order base sa presyo kada follower nga magpabilin, dili sa nakasulat nga presyo, ug ang samang lohika ang nagtakda sa among singil. Usahay kami gyud ang labing barato; kung dili, ang kalainan mao ang pagpalit ug delivery nga magpabilin.',
      },
      speed: {
        q: 'Unsa kapaspas magsugod ang order?',
        a1: 'Kadaghanan sa mga serbisyo magsugod sulod sa pipila ka minuto. Gipakita sa matag usa ang kasagarang oras sa pagsugod ug kapaspason niini sa order form, gikan sa tinuod nga gibuhat sa maong serbisyo ug dili sa saad.',
        a2: 'Ang order nga wala pa molihok makita sa imong lista sa mga order uban sa live status niini, ug ma-email ka kung mahuman.',
      },
      partial: {
        q: 'Unsa kung bahin ra sa order ang nahatod?',
        a1: 'Awtomatik nga i-refund ang wala mahatod nga bahin, sa presyong imong gibayad, ug mobalik ang kwarta sa imong wallet nga wala nimo pangayoa. Ang hingpit nga napakyas nga order i-refund sa tibuok sa samang paagi.',
        a2: 'Gikwenta ang refund gikan sa order ug gisulat sa ledger sa sistema, dili sa tawong modesisyon kung tumanon ba.',
      },
      cancel: {
        q: 'Mahimo ba nako kanselahon ang order?',
        a1: 'Sa mga serbisyong nagsuporta sa pagkansela, oo — mogawas ang opsyon sa order mismo. Daghang serbisyo dili na makansela kung nagsugod na ang delivery, ug gisulti sa order form kung hain sa dili pa ka mopalit, dili pagkahuman.',
      },
      link: {
        q: 'Unsang link ang akong ihatag?',
        a1: 'Kung unsa ang gipangayo sa serbisyo: profile URL para sa followers, post URL para sa likes o views, usahay username ra. Gisulti sa field kung hain ug gibalibaran ang sayop nga porma sa dili pa ka mobayad, dili mapakyas pagkahuman.',
        a2: 'Kinahanglan public ang imong account samtang nagdagan ang order. Dili makadawat ug delivery ang private nga account, ug dili kana maayo sa refill.',
      },
      payment: {
        q: 'Unsaon nako pagbayad?',
        a1: 'Card, ug lokal nga paagi sa pagbayad kung asa namo gisuportahan — sa Pilipinas, GCash, Maya ug GrabPay.',
        a2: 'Mosulod una ang kwarta sa wallet balance, ug mokuha dinhi ang mga order. Buot ipasabot, dili gyud maghulat ang order sa pag-clear sa bayad, ug diha-diha moabot ang refund imbes ibalik agi sa card network.',
      },
      regional: {
        q: 'Ngano nga mas ubos ang presyo sa pipila ka nasod?',
        a1: 'Kay ang presyong makatarunganon sa London dili makatarunganon sa Manila. Ang mga customer nga mobayad gikan sa gisuportahang nasod adunay lokal nga lista sa presyo.',
        a2: 'Makuha kini pinaagi sa paagi sa pagbayad, dili sa kung asa ka murag nag-browse — lokal nga e-wallet o card nga gi-isyu sa maong nasod. Mas patas kana kaysa location detection, nga sayon pekeon ug sayop nga mobabag sa mga nagtrabaho sa gawas nga mopalit para sa pamilya sa balay.',
      },
      refundWallet: {
        q: 'Mahimo ba nako i-withdraw ang akong wallet balance?',
        a1: 'Ang kwarta sa wallet para sa mga order ug dili ma-withdraw. Pagdeposito sa imong planong gastuhon imbes magtipig ug balanse.',
        a2: 'Bisan unsang gi-refund gikan sa napakyas o kulang nga order mobalik sa wallet ug magamit sa lain.',
      },
      password: {
        q: 'Kinahanglan ba ninyo ang akong password?',
        a1: 'Dili. Bisan kanus-a. Public link o username ra ang among gipangayo ug wala nay lain.',
        a2: 'Bisan unsang serbisyo bisan asa nga mangayo sa imong password sa social media nagkompromiso sa imong account o hapit na. Walay lehitimong rason niini.',
      },
      safe: {
        q: 'Luwas ba kini para sa akong account?',
        a1: 'Wala gyud namo hikapa ang imong login, ug mahitabo ang delivery gikan sa gawas sa imong account. Ang matinud-anong pahimangno: supak sa terms of service sa matag dakong platform ang pagpalit ug engagement, ug ila ang pagpatuman, dili amo.',
        a2: 'Sa praktika: ipabilin nga proporsyonal ang mga order sa gidak-on sa imong account, likayi ang pag-order sa samang butang nga balik-balik sa mubong panahon, ug isipa nga risgo ang bisan unsang murag kalit. Ang hinay nga pagtubo murag hinay nga pagtubo.',
      },
      signup: {
        q: 'Ngano nga makasign up ko nga walay email?',
        a1: 'Aron makaorder ka sa wala pay usa ka minuto. Igo na ang username ug password aron magsugod.',
        a2: 'Tinuod ang baylo ug among gisulti dayon: kung walay email, dili namo mabawi ang imong account o mapadad-an ka ug resibo, busa ang account nga walay email papason human sa 5 ka adlaw. Ang pagdugang ug email bisan kanus-a magpabilin niini. Ang account nga adunay balanse, order o bayad dili gyud awtomatik papason — ipasa kini sa tawo.',
      },
      privacy: {
        q: 'Unsa ang inyong buhaton sa akong data?',
        a1: 'Among gitipigan ang kinahanglan aron modagan ang imong mga order ug wala nay lain. Wala namo kini gibaligya, ug wala kami nag-post bisan asa.',
        a2: 'Ang tibuok detalye anaa sa patakaran sa privacy, nga gisulat aron basahon ug dili aron antuson.',
      },
    },
  },

  help: {
    key: 'Help centre',
    title: 'Pangutan-a ang mga tawong nagpadagan niini.',
    lede: 'Walay inbox dinhi. Ang tanan mahimong ticket sa usa ka queue nga gitrabahoan sa among staff, ug dili gyud nimo kinahanglan ug email aron matabangan, o aron mabasa ang tubag.',
    points: {
      findTitle: 'Na-lock out? Pangitaa ang imong order',
      findBody:
        'Ang order number, ang username sa account, ug ang katapusang upat ka character sa payment reference nagpamatuod nga imo kini. Unya makita nimo kung unsa gyud ang nahitabo niini.',
      autoTitle: 'Kadaghanan sa tubag wala magkinahanglan ug tawo',
      autoBody:
        'Ang kulang nga delivery awtomatik nga mo-refund, ang pagkunhod awtomatik nga mo-refill, ug gisulti sa order page kung hain ang nahitabo. Kung kinahanglan na ug tawo, ipasa gikan sa samang screen.',
      repliesTitle: 'Anaa sa ticket ang mga tubag',
      repliesBody:
        'Kung naka-sign in, ubos sa Support. Kung wala, sa page nga giablihan sa number ug key. Walay gi-email, ug wala gyud kami mangayo ug password sa social media.',
    },
    asideGuest:
      'Adunay account ug nahinumdom sa password? {link} ug tipigan ang mga ticket ubos sa Support para nimo.',
    asideGuestLink: 'Mag-sign in',
    asideUser: 'Anaa sa {link} ang imong mga ticket, tapad sa imong mga order.',
    asideUserLink: 'Support',
    laneOrder: 'Pangitaa ang akong order',
    laneTicket: 'Mag-open ug ticket',

    findFailed: 'Dili namo matakdo kana nga mga detalye sa usa ka order.',
    refreshFailed: 'Dili ma-refresh ang order',
    orderNumber: 'Order number',
    orderNumberPlaceholder: 'pan. 1042',
    orderNumberHint: 'Makita sa order page ug sa confirmation.',
    username: 'Username sa account',
    usernamePlaceholder: 'imongngalan',
    last4: 'Katapusang upat ka character sa payment reference',
    last4Placeholder: 'pan. 9QX2',
    last4Hint:
      'Bisan unsang nahuman nga deposito sa account. Ingon niini ang reference: PAY-7F3K9QX2, sa wallet page ug mga resibo.',
    findOrder: 'Pangitaa ang order',
    findFoot:
      'Walay payment reference sa kamot? Mag-open na lang ug ticket ug ihatag ang order number; adunay tawong mo-verify niini uban nimo.',

    status: {
      PENDING: 'Nakalinya',
      QUEUED: 'Nakalinya',
      SUBMITTING: 'Gipasa',
      PROCESSING: 'Giproseso',
      IN_PROGRESS: 'Nagahatod',
      PARTIAL: 'Bahin ra',
      COMPLETED: 'Nahuman',
      CANCELED: 'Gikansela',
      FAILED: 'Napakyas',
      REFUNDED: 'Gi-refund',
    },
    orderKey: 'Order #{number}',
    orderMeta: '{platform} · {quantity} gi-order · {charge} · gibutang {date}',
    done: 'Human na',
    providerNote: 'Nota sa provider: {note}',
    refundedToWallet: 'Gi-refund sa wallet',
    checkAfter: 'Pagsusi human sa {n} ka adlaw | Pagsusi human sa {n} ka adlaw',
    stillThere: '{held}% nagpabilin',
    due: 'sa {date}',
    refillAt: 'Refill {date}',
    ticketNumber: 'Ticket #{number}',

    escalatedTitle: 'Anaa na sa tawo ang Ticket #{number}.',
    escalatedBody:
      'Nakatala kini ubos niini nga order ug sa account. Kini nga link moabli niini samtang naka-lock out ka; kini ra ang kopya sa key.',
    copy: 'Kopyaha',
    copied: 'Nakopya',
    copyLink: 'Kopyaha ang link',
    openTheTicket: 'Ablihi ang ticket',
    needPersonTitle: 'Kinahanglan pa gihapon ug tawo?',
    needPersonBody:
      'Ipasa kini nga order sa support. Makita nila ang tanan sa ibabaw, lakip ang bahin sa provider.',
    escalate: 'Ipasa sa tawo',
    escalateLabel: 'Unsa ang angay nilang mahibaloan?',
    escalatePlaceholder:
      'Ang imong gipaabot, ang imong nakita, ug bisan unsang wala mapasabot sa mga numero sa ibabaw.',
    reachYou: 'Paagi aron maabot ka',
    reachYouEscPlaceholder: 'Opsyonal: usa ka handle. Mogawas ang mga tubag sa ticket bisan unsa pa.',
    escalateFailed: 'Dili ma-open ang ticket',

    emailAttached: 'Nataod na ang email.',
    noEmailTitle: 'Walay email address kini nga account.',
    noEmailBody:
      'Pagtaod ug usa ug ma-reset ang password sa normal nga paagi. Didto ra kini gamiton ug para sa mga resibo.',
    attachEmail: 'Pagtaod ug email',
    emailLabel: 'Email para niini nga account',
    emailPlaceholder: "ikaw{'@'}example.com",
    attachSend: 'Itaod ug magpadala ug verification',
    attachFailed: 'Dili mataod kana nga email',
    viewStays: 'Abli kini nga view sulod sa 30 ka minuto.',
    refreshOrder: 'I-refresh ang order',

    yourTickets: 'Imong mga abli nga ticket',
    ticketOpened: 'Na-open ang ticket',
    queuedTitle: 'Ikaw ang {number} sa linya.',
    queuedToast: 'Anaa na sa linya ang #{number}.',
    sentLede:
      'Gipahibalo na ang staff. Kini nga link moabli sa imong ticket, magpakita sa matag tubag, ug motugot nimo motubag. Kini ra ang kopya sa imong key, busa tipigi sa luwas nga dapit.',
    sendAnother: 'Magpadala ug lain',
    sentNote:
      'Nahinumdom usab kini nga browser sa key, busa molihok ang pagbalik sa ticket page dinhi bisan walay link.',
    yourName: 'Imong ngalan',
    yourNamePlaceholder: 'Unsa ang among itawag nimo?',
    reachYouPlaceholder: 'Opsyonal: usa ka handle, o ang imong username dinhi',
    reachYouHint: 'Kung gusto ra nimo. Mogawas ang mga tubag sa ticket bisan unsa pa.',
    about: 'Mahitungod kini sa',
    topic: 'Hilisgutan',
    topics: {
      ORDER: 'Usa ka order',
      PAYMENT: 'Usa ka bayad',
      ACCOUNT: 'Akong account',
      REFILL: 'Usa ka refill',
      OTHER: 'Lain pa',
    },
    subject: 'Hilisgutan',
    subjectPlaceholder: 'Usa ka linya mahitungod niini',
    message: 'Mensahe',
    messagePlaceholder:
      'Unsa ang nahitabo, unsa ang imong gipaabot, ug bisan unsang makatabang namo sa pagpangita: order number, link, oras.',
    messageHint: 'Makatabang ang order number ug link. Password, dili gyud — dili kami mangayo.',
    submitGuest: 'Mag-open ug ticket',
    submitUser: 'Mag-open ug ticket ubos sa akong account',
    sendFailed: 'Dili mapadala ang imong mensahe',
    faqFoot:
      'Nangita una ug tubag? Gisakop sa {link} ang mga pangutana nga tinuod nga gipangutana sa mga tawo, lakip ang mga dili komportable nga tubag.',
    faqFootLink: 'FAQ',
  },

  ticket: {
    number: 'Ticket #{number}',
    opening: 'Giablihan…',
    needsKey: 'Kinahanglan niini nga ticket ang key niini.',
    wrongKey: 'Dili maabli kana nga key niini nga ticket.',
    needsKeyBody:
      'Dala kini sa link nga gihatag nimo sa dihang nag-open ka ug ticket. I-paste sa ubos ang key gikan sa maong link.',
    mismatch: 'Dili magtakdo kana nga ticket number ug key.',
    keyLabel: 'Key',
    keyPlaceholder: 'I-paste ang key gikan sa imong link',
    openTicket: 'Ablihi ang ticket',
    lostKey: 'Nawala ang key? Dili kini mabawi. {link} ug hisguti ang #{number} aron mahiusa namo ang duha.',
    lostKeyLink: 'Mag-open ug bag-ong ticket',
    status: {
      OPEN: 'Abli',
      PENDING_SUPPORT: 'Naghulat sa support',
      PENDING_CUSTOMER: 'Naghulat nimo',
      RESOLVED: 'Nasulbad',
      CLOSED: 'Sirado',
    },
    opened: 'Giablihan {date}',
    with: 'uban ni {name}',
    staff: '{name} · Support',
    you: 'Ikaw',
    reply: 'Tubag',
    replyPlaceholder: 'Pagdugang ug bisan unsang makatabang, o tubaga ang pangutana sa support.',
    repliesHere: 'Mogawas dinhi ang mga tubag; walay gi-email.',
    sendReply: 'Ipadala ang tubag',
    sendFailed: 'Dili mapadala ang imong tubag',
    closed: 'Sirado na kini nga ticket. Kung adunay sayop pa, {link} ug hisguti ang #{number}.',
    closedLink: 'mag-open ug bag-o',
  },

  legal: {
    updated: 'Gi-update {date}',
    sections: '{n} ka seksyon | {n} ka seksyon',
    minRead: '{n} min basahon',
    contents: 'Sulod',
    plainWords: 'Sa yanong pulong',
    keepReading: 'Padayon sa pagbasa',
    backToTop: 'Balik sa ibabaw',
  },
}
